/**
 * `펀딩` 뱃지 타입
 */
export enum MpsFundingBadgeType {
  MEMBERSHIP = 'MEMBERSHIP',
  FUNDING = 'FUNDING',

  // 펀딩 종료
  CLOSED = 'CLOSED',

  UPCOMING = 'UPCOMING',
  QUANTITY = 'QUANTITY',
  PERIOD = 'PERIOD',
}
